// src/services/noteTypeService.js
import api from './api';

export function fetchNoteTypes() {
  return api.get('/noteTypes');
}

export function getNoteTypeById(id) {
  return api.get(`/noteTypes/${id}`);
}

export function createNoteType(data) {
  return api.post('/noteTypes', data);
}

export function updateNoteType(data) {
  return api.put(`/noteTypes/${data.noteTypeId}`, data);
}

export function deleteNoteType(id) {
  return api.delete(`/noteTypes/${id}`);
}

export function deleteNoteTypesBatch(ids) {
  return api.delete('/noteTypes', { data: ids }); // importante: usar 'data' no DELETE
}

export async function fetchNoteTypesPaged(pageNumber, pageSize, search = '') {
  return api.get('/noteTypes/paged', {
    params: {
      pageNumber,
      pageSize,
      search
    }
  });
}